export const filesValidation = (data, type, schema, t, isOpenUploadModal) => {
  let err = []
  if (schema.custom.validation && schema.custom.validation.length) {
    schema.custom.validation.forEach((validationItem) => {
      if (data) {
        const maxValue = validationItem.parameters.maximumValue
        if (validationItem.validationType === 'FileAttachmentMaxNumber') {
          if (type === 'drop') {
            if (data.length > maxValue) {
              if (isOpenUploadModal) {
                err = err.concat(t('ducs.files_can_be_selected', {MaximumFiles: maxValue} ))
              } else {
                err = err.concat(t('ducs.files_can_be_attached', {MaximumFiles: maxValue}))
              }
            }
          }
          if (type === 'click') {
            if (data.length >= maxValue) {
              if (isOpenUploadModal) {
                err = err.concat(t('ducs.files_can_be_selected', {MaximumFiles: maxValue}))
              } else {
                err = err.concat(t('ducs.files_can_be_attached', {MaximumFiles: maxValue}))
              }
            }
          }
        }
        if (validationItem.validationType === 'FileAttachmentMaxSize') {
          data.map((file) => {
            const sizeInMB = ((file.Size || file.size / 1024) / 1000).toFixed(3)
            if (Number(sizeInMB) > maxValue) {
              err = err.concat(t('ducs.file_exceed_maximum_size', {MaximumSize: maxValue, FileName: file.FileName || file.name}))
            }
          })
        }
      }
    })
  }
  return err
}

export const getRepositoryFiles = (isRepo, options, formContext) => {
  return isRepo &&
    options.custom.repositories.length && options.custom.repositories.map(async (item) => {
      return await formContext.UStoreProvider.api.orders.getRepositoryDetails(item.id)
        .then((res) => {
          if (res.Files.length > 0) {
            const files = res.Files.reduce((acc, next) => {
              return next.Path.includes('\\')
                ? acc.concat({...next, Path: next.Path.replace(/\134/g, "/")})
                : acc.concat(next)
            }, [])
            return {...res, Files: files}
          }
        })
        .catch((err) => console.log('get data error: ', err))
    })
}

export const isValueValidJson = (value) => {
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }
  return true
}
